module.exports = __webpack_public_path__ + "static/media/chicken.88271225.jpg";